import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlService {

  private readonly returnUrlKey = 'returnUrl';

  /**
   * Save the page the user originally wanted to visit.
   */
  setReturnUrl(url: string): void {
    if (!url) {
      return;
    }

    sessionStorage.setItem(this.returnUrlKey, url);
  }

  /**
   * Get the saved URL.
   */
  getReturnUrl(): string | null {
    return sessionStorage.getItem(this.returnUrlKey);
  }

  /**
   * Get the saved URL and remove it immediately.
   */
  consumeReturnUrl(): string | null {
    const url = this.getReturnUrl();

    sessionStorage.removeItem(this.returnUrlKey);

    return url;
  }

  /**
   * Remove saved URL manually.
   */
  clearReturnUrl(): void {
    sessionStorage.removeItem(this.returnUrlKey);
  }
}